import { api } from "./api";

export const obtenerTodosLosAutores = async () => {
  const { data } = await api.get("/autores/all");
  return data;
};

export const agregarAutor = async (autor) => {
  const { data } = await api.post("/autores/save", autor);
  return data;
};

export const actualizarAutor = async (idAutor, autor) => { 
  const { data } = await api.put(`/autores/update/${idAutor}`, autor);
  return data;
};

export const deshabilitarAutor = async (idAutor) => {
  const { data } = await api.put(`/autores/deshabilitar/${idAutor}`, {});
  return data;
};

